var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #353535;\r\n        stroke-linecap: round;\r\n        stroke-width: 3px;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-2 \r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #353535;\r\n      }\r\n    "))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.30639,11.25243a5.29412,5.29412,0,1,0-10.58824,0,5.23707,5.23707,0,0,0,.584,2.37007A5.27955,5.27955,0,0,0,8.8358,23.95831"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.58191,21.56266a7.00047,7.00047,0,1,0,11.32225,6.78321V28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.43086,42.32855A6.21606,6.21606,0,0,1,5.108,36.82494a6.14985,6.14985,0,0,1,.68573-2.78316"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19,16a5,5,0,0,1-5,5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "19 16.01 30.5 16.01 32.521 13.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "25.5 20.01 31.5 20.01 33.521 17.99 39 17.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "24.917 31.99 30.5 31.99 32.521 34.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "24.917 27.99 31.5 27.99 33.521 30.01 39 30.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39,38.01018H31.52094l-1.52061-2.02061-4.95867.00011v6.05209a5,5,0,0,1-10,0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.04167,4.13392a4.05277,4.05277,0,0,1,8,.91833V12.01l4.45868.00013L31.521,9.98956H39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 36,
    x2: 25.04167,
    y1: 24,
    y2: 24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 11,
    cy: 20,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 11.79167,
    cy: 43.5,
    r: 1
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 41.47922,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 41.47922,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 41.47922,
    cy: 30,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 41.47922,
    cy: 38,
    r: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAi);
export default __webpack_public_path__ + "static/media/ic_ai.8d1f70c219d1b8a922869d7c02936d1e.svg";
export { ForwardRef as ReactComponent };